var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('header',{staticClass:"login-header"},[_vm._t("logo"),_vm._m(0)],2),_c('ForgotEmailForm')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"login-header-text"},[_c('h2',[_vm._v("Forgot your email?")]),_c('p',[_vm._v("No problem! Send us your information and we will contact you with your next steps.")])])
}]

export { render, staticRenderFns }